
import { ReceivingContacts } from "./ReceivingContacts";
import { ContactInsight } from "./ContactInsight";
import { generateEmail } from "../../domain/receiving-log/rules/generate-email";

export interface PoEmailData {
    contact: string;
   /**
    * True only when `contact` is an `@macmiller.com` address we can actually email.
    * False means the PO gave us a name (or a name with a phone number, or an
    * off-domain address) and the user has to supply the real address from the
    * employee directory — nothing is guessed. See `generateEmail`.
    */
   isValidEmail: boolean;
   /** BambooHR-resolved metadata for this email, when the PO fetch supplied it. */
   insight?: ContactInsight;
  }
  export class FormattedContacts {
    public constructor(init?: Partial<ReceivingContacts>, insights?: ContactInsight[]) {
        // Resolve each generated email to its insight (keyed by lower-cased email).
        const insightByEmail = new Map<string, ContactInsight>(
            (insights || [])
                .filter(i => i && i.email)
                .map(i => [i.email.trim().toLowerCase(), i]),
        );
        if (init) {
            Object.assign(this, {
                dataFromMacBuy: init.dataFromMacBuy});
//             init.poCreator = 'f';
//             init.notify= ['h'];
//             init.shipToAttention = 'bob joe';
// init.requestedBy = 'tyty';

            // Assign relevant properties from ReceivingContacts to FormattedContacts
       

            const allContactEmails: PoEmailData[] = [];
            let notify: string[] = [];

            // Helper function to convert a contact into an emailData object,
            // attaching its BambooHR insight when one matches the generated email.
            const toEmailData = (contact: string): PoEmailData => {
                const base = generateEmail(contact);
                const insight = insightByEmail.get(base.contact.trim().toLowerCase());
                return insight ? { ...base, insight } : base;
            };

            // Additional logic: Check if dataFromMacBuy is true
            if (init.dataFromMacBuy) {
                // Filter out poCreator's contact from the notify list, if dataFromMacBuy is true
                notify = (init.notify || []).filter(item => item !== init.poCreator);

            } else {
                // Use the notify array as is
                notify = init.notify || [];
            }

            const notifyEmailData = notify.map(contact => toEmailData(contact));
            this.notify = notifyEmailData;
            const validNotifyEmailData = notifyEmailData.filter(email => email.isValidEmail);
            allContactEmails.push(...validNotifyEmailData);

            
    
            // Process other contact fields and generate email data
            if (init.poCreator) {
                const formattedPoCreator = toEmailData(init.poCreator);
                this.poCreator = formattedPoCreator;
                if (formattedPoCreator.isValidEmail) {
                    allContactEmails.push(formattedPoCreator);
                }
            }
            if (init.shipToAttention) {
                const formattedShipToAttention = toEmailData(init.shipToAttention);
                this.shipToAttention = formattedShipToAttention;
                if (formattedShipToAttention.isValidEmail)       allContactEmails.push(formattedShipToAttention);
            }
            if (init.requestedBy) {
                const formattedRequestedBy = toEmailData(init.requestedBy);
                this.requestedBy = formattedRequestedBy;
                if (formattedRequestedBy.isValidEmail)       allContactEmails.push(formattedRequestedBy);
            }

            // Set the final processed list of contact emails
            this.allContactEmails = allContactEmails;

        }
    }

    dataFromMacBuy!: boolean;
    notify!: PoEmailData[];
    poCreator!: PoEmailData; 
    shipToAttention!: PoEmailData; 
    requestedBy!: PoEmailData; //
    allContactEmails!: PoEmailData[];
}
